import LegalPage, { LegalSection, LP } from "@/components/LegalPage";

export default function PrivacyPage() {
  return (
    <LegalPage
      title="Politique de confidentialité"
      subtitle="Cette politique explique quelles données personnelles nous collectons, pourquoi, et comment vous gardez le contrôle sur vos informations."
      updated="16 juin 2026"
      testId="privacy-page"
    >
      <LegalSection id="responsable" title="1. Responsable du traitement">
        <LP>
          La plateforme <strong>Zevents</strong>, éditée par <strong>ALO FINANCES</strong> (« nous »), est responsable
          du traitement des données personnelles collectées via le site et l'application. Pour toute question relative
          à vos données : <strong>support@alofinances.com</strong>.
        </LP>
      </LegalSection>

      <LegalSection id="donnees-collectees" title="2. Données que nous collectons">
        <ul style={{ margin: "0 0 12px", paddingLeft: 20 }}>
          <li><strong>Données de compte</strong> : nom, e-mail, mot de passe (chiffré), rôle, ville, téléphone, logo/bio (organisateurs).</li>
          <li><strong>Données invité</strong> : nom, e-mail et, si fourni, numéro de téléphone, pour permettre l'achat ou la participation sans compte.</li>
          <li><strong>Données de transaction</strong> : billets achetés, contributions, bons d'achat, montants. Les données de paiement complètes sont traitées par notre prestataire de paiement, nous n'y avons pas accès.</li>
          <li><strong>Données d'usage</strong> : participation aux votes/sondages, listes d'attente, préférences de notification.</li>
          <li><strong>Données techniques</strong> : informations de connexion, jeton de session stocké localement sur votre appareil.</li>
        </ul>
      </LegalSection>

      <LegalSection id="finalites" title="3. Pourquoi nous utilisons vos données">
        <ul style={{ margin: "0 0 12px", paddingLeft: 20 }}>
          <li>Créer et gérer votre compte et vos billets.</li>
          <li>Traiter les achats, contributions et bons d'achat.</li>
          <li>Vous envoyer les confirmations, billets (QR), reçus et rappels d'événement par <strong>e-mail</strong> et/ou <strong>SMS</strong>.</li>
          <li>Vous prévenir lorsqu'une place se libère (liste d'attente).</li>
          <li>Assurer la sécurité, prévenir la fraude et respecter nos obligations légales.</li>
        </ul>
      </LegalSection>

      <LegalSection id="base-legale" title="4. Bases légales">
        <LP>
          Nous traitons vos données sur la base de : l'<strong>exécution du contrat</strong> (fourniture du service),
          votre <strong>consentement</strong> (notifications marketing, SMS), notre <strong>intérêt légitime</strong>
          (sécurité, amélioration du service) et le respect de nos <strong>obligations légales</strong>.
        </LP>
      </LegalSection>

      <LegalSection id="destinataires" title="5. Destinataires et sous-traitants">
        <LP>Vos données ne sont jamais vendues. Elles peuvent être partagées avec :</LP>
        <ul style={{ margin: "0 0 12px", paddingLeft: 20 }}>
          <li><strong>L'Organisateur</strong> de l'événement auquel vous participez (pour la gestion des entrées et des contacts liés à l'événement).</li>
          <li><strong>Notre prestataire d'e-mails</strong> (Resend) pour l'envoi des e-mails transactionnels.</li>
          <li><strong>Notre prestataire de SMS</strong> (Lengo SMS) pour l'envoi des SMS, lorsque vous fournissez un numéro.</li>
          <li><strong>Notre prestataire de paiement agréé</strong> pour le traitement sécurisé des paiements.</li>
          <li><strong>Notre hébergeur</strong> pour le fonctionnement technique de la Plateforme.</li>
        </ul>
      </LegalSection>

      <LegalSection id="notifications" title="6. E-mails et SMS — votre contrôle">
        <LP>
          Vous pouvez à tout moment activer ou désactiver les notifications par e-mail et par SMS depuis votre espace
          <strong> Profil → Notifications</strong>. Les SMS ne sont envoyés que si vous avez fourni un numéro de
          téléphone. Les messages liés à une transaction (billet, reçu) peuvent être nécessaires à l'exécution du service.
        </LP>
      </LegalSection>

      <LegalSection id="conservation" title="7. Durée de conservation">
        <LP>
          Nous conservons vos données aussi longtemps que nécessaire à la fourniture du service et au respect de nos
          obligations légales et comptables, puis les supprimons ou les anonymisons.
        </LP>
      </LegalSection>

      <LegalSection id="securite" title="8. Sécurité">
        <LP>
          Nous mettons en œuvre des mesures techniques et organisationnelles appropriées (chiffrement des mots de
          passe, accès restreint, connexions sécurisées) pour protéger vos données contre tout accès non autorisé.
        </LP>
      </LegalSection>

      <LegalSection id="droits" title="9. Vos droits">
        <LP>
          Vous disposez d'un droit d'<strong>accès</strong>, de <strong>rectification</strong>, d'<strong>effacement</strong>,
          d'<strong>opposition</strong>, de <strong>limitation</strong> et de <strong>portabilité</strong> de vos données.
          Pour exercer ces droits, écrivez-nous à <strong>support@alofinances.com</strong>. Vous pouvez également
          retirer votre consentement aux notifications à tout moment.
        </LP>
      </LegalSection>

      <LegalSection id="cookies" title="10. Stockage local et cookies">
        <LP>
          La Plateforme utilise le stockage local de votre navigateur (par exemple pour mémoriser votre session de
          connexion et empêcher les votes en double en mode invité). Ces données restent sur votre appareil et sont
          nécessaires au bon fonctionnement du service.
        </LP>
      </LegalSection>

      <LegalSection id="mineurs" title="11. Mineurs">
        <LP>
          La Plateforme n'est pas destinée aux mineurs sans le consentement et la supervision d'un représentant légal.
          Nous ne collectons pas sciemment de données de mineurs sans autorisation.
        </LP>
      </LegalSection>

      <LegalSection id="transferts" title="12. Transferts de données">
        <LP>
          Certains de nos prestataires peuvent traiter des données en dehors de votre pays de résidence. Dans ce cas,
          nous veillons à ce que des garanties appropriées soient mises en place.
        </LP>
      </LegalSection>

      <LegalSection id="modifs" title="13. Modifications de cette politique">
        <LP>
          Nous pouvons mettre à jour cette politique. La version en vigueur est celle publiée sur cette page. En cas
          de changement important, nous vous en informerons par les moyens appropriés.
        </LP>
      </LegalSection>

      <LegalSection id="contact" title="14. Contact">
        <LP>
          Pour toute question sur vos données personnelles : <strong>support@alofinances.com</strong>.
        </LP>
      </LegalSection>
    </LegalPage>
  );
}
